import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

import { SedsButtonTypeOptions } from './enums/seds-button-type-options.enum';
import { SedsThemeColorOptions } from '../../shared/enums/seds-theme-color-options.enum';
import { SedsThemeColorOptionsType } from '../../shared/types/seds-theme-color-options.type';

@Component({
    template: '',
    standalone: false
})
export abstract class SedsButtonAbstractComponent {
  @Input()
  color: SedsThemeColorOptions | SedsThemeColorOptionsType = SedsThemeColorOptions.PRIMARY;

  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: BooleanInput) {
    this._disabled = coerceBooleanProperty(value);
  }

  @Input()
  iconName = '';

  type!: SedsButtonTypeOptions;

  private _disabled = false;
}
